/**
 * This file is used to configure the app
 *
 * If you have the "Cannot find name 'defineAppConfig'.ts(2304)" error
 * update the root tsconfig.json file to include the following:
 *
 *  "extends": "./.app/.nuxt/tsconfig.json"
 *
 */

export default defineAppConfig({
  title: 'SecuCheck',
  nav: [
    {
      name: 'Accueil',
      icon: { name: 'ph:house-simple', class: 'size-5' },
      to: '/',
    },
    {
      name: 'Collaborateurs',
      icon: { name: 'ph:user', class: 'size-5' },
      to: '/collaborators?isActive',
    },

    {
      name: 'QR Code',
      icon: { name: 'ph:qr-code', class: 'size-5' },
      to: '/redirects',
    },
    {
      divider: true,
      shouldRender: (user: any) => {
        return ['admin'].some((x) => user?.roles?.includes(x))
      },
    },
    {
      name: 'Admin',
      icon: { name: 'ph:handshake', class: 'size-5' },
      activePath: '/admin',
      shouldRender: (user: any) => {
        return ['admin'].some((x) => user?.roles?.includes(x))
      },
      children: [
        {
          name: 'Etablissement',
          icon: { name: 'ph:building-duotone', class: 'size-5' },
          to: '/tenants',
          position: 'end',

          shouldRender: (user: any) => {
            return ['admin'].some((x) => user?.roles?.includes(x))
          },
        },
        {
          name: 'Gestion des entités',
          icon: { name: 'ph:table-duotone', class: 'size-5' },
          to: '/admin/entities',
          position: 'end',

          shouldRender: (user: any) => {
            return ['admin'].some((x) => user?.roles?.includes(x))
          },
        },
        {
          name: 'Intégrations',
          icon: { name: 'ph:puzzle-piece', class: 'size-5' },
          to: '/admin/integrations',
          position: 'end',

          shouldRender: (user: any) => {
            return ['admin'].some((x) => user?.roles?.includes(x))
          },
        },
      ],
    },
  ],
  toaster: {
    theme: {
      containerClass: ['fixed', 'p-2', 'flex', 'items-center', 'justify-end'],
      wrapperClass: ['pointer-events-auto', 'cursor-pointer'],
    },
  },
  tairo: {
    title: 'FormApp',
    collapse: {
      circularMenu: {
        enabled: false,
        tools: [],
      },
      toolbar: {
        enabled: true,
        showTitle: true,
        showNavBurger: true,
        tools: [
          {
            component: 'ToolbarAccountMenu',
          },
        ],
      },
      navigation: {
        enabled: true,
        header: {
          component: 'AppLogo',
        },
        items: [],
      },
    },
  },
})
